__turbopack_context__.v({
  "accordionHoverTagClose": "Accordion-module-scss-module__fiCu8a__accordionHoverTagClose",
  "active": "Accordion-module-scss-module__fiCu8a__active",
  "answer": "Accordion-module-scss-module__fiCu8a__answer",
  "question": "Accordion-module-scss-module__fiCu8a__question",
  "readMoreBtn": "Accordion-module-scss-module__fiCu8a__readMoreBtn",
  "toogleIcon": "Accordion-module-scss-module__fiCu8a__toogleIcon",
  "wrapper": "Accordion-module-scss-module__fiCu8a__wrapper",
});
